/* eslint-disable */
/* tslint:disable */

import { LegendTooltip, LegendTooltipParams } from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

class Tooltip<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
	/**
	 * No description
	 *
	 * @tags Легенда подсказок
	 * @summary Получить список подсказок
	 * @request GET:/tooltip
	 * @secure
	 */
	tooltipList = (
		query: {
			/** url подсказки */
			url: string;
		},
		params: RequestParams = {},
	) =>
		this.request<LegendTooltip[], void>({
			path: `/tooltip`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Легенда подсказок
	 * @summary Редактировать подсказку
	 * @request PUT:/tooltip
	 * @secure
	 */
	tooltipUpdate = (data: LegendTooltip, params: RequestParams = {}) =>
		this.request<LegendTooltip, void>({
			path: `/tooltip`,
			method: "PUT",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Легенда подсказок
	 * @summary Добавить подсказку
	 * @request POST:/tooltip
	 * @secure
	 */
	tooltipCreate = (data: LegendTooltip, params: RequestParams = {}) =>
		this.request<LegendTooltip, void>({
			path: `/tooltip`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Легенда подсказок
	 * @summary Удалить подсказку
	 * @request DELETE:/tooltip
	 * @secure
	 */
	tooltipDelete = (data: LegendTooltipParams, params: RequestParams = {}) =>
		this.request<any, void>({
			path: `/tooltip`,
			method: "DELETE",
			body: data,
			secure: true,
			type: ContentType.Json,
			...params,
		});
}
export const tooltipAPI = new Tooltip();
